import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../firebase";

export interface IndividualHonor {
  score: string;
  name: string;
  team: string;
  note: string;
}

// The individual lists name students, so they are read at runtime rather than
// compiled into the bundle. armlResults is world-readable by rule; the page
// that renders it is served with a noindex header.
class ArmlResultsService {
  async getIndividualHonors(season: string): Promise<IndividualHonor[] | null> {
    if (!firestore) {
      console.error("Firestore not initialized");
      return null;
    }

    try {
      const snapshot = await getDoc(doc(firestore, "armlResults", season));
      if (!snapshot.exists()) {
        return null;
      }
      const data = snapshot.data() as {
        individualHonors?: IndividualHonor[];
      };
      return data.individualHonors ?? null;
    } catch (err) {
      console.error("Error fetching ARML individual honors:", err);
      return null;
    }
  }
}

export const armlResultsService = new ArmlResultsService();
